import { ReserveUnitScreen } from '@/modules/property-details/ReserveUnitScreen';

export default function ReserveUnitRoute() {
    return <ReserveUnitScreen />;
}
